import React from "react";

const InputText = ({ className, children, refs, type = "text" }) => {
  return (
    <>
      {refs && (
        <input {...refs} type={type} className={`input-custom ${className}`}>
          {children}
        </input>
      )}
    </>
  );
};

export default InputText;
